import axios from '@/http/index';

const base = '';
// (5.2)套餐划扣详情
export const getVipCardAnalyse = (params) => axios.get(`${base}/erp/analyse/getVipCardAnalyse`, params).then((res) => res.data);
// (5.2)套餐概况
export const getVipCardSaleAndDeductMsg = (params) => axios.get(`${base}/erp/analyse/getVipCardSaleAndDeductMsg`, params).then((res) => res.data);
// (5.2)套餐销售(上面的总数量)
export const getVipCardSaleDetailMsg = (params) => axios.get(`${base}/erp/analyse/getVipCardSaleDetailMsg`, params).then((res) => res.data);
// (5.2)套餐销售（下面的分页数量）
export const getVipCardSaleDetailPage = (params) => axios.get(`${base}/erp/analyse/getVipCardSaleDetailPage`, params).then((res) => res.data);
// 5.2导出套餐划扣
export const exportVipCardDeduct = (params) => axios.get(`${base}/erp/analyse/exportVipCardDeduct`, params).then((res) => res.data);
// （5.2）导出套餐销售（下面的分页数量）
export const exportVipCardSaleDetailPage = (params) => axios.get(`${base}/erp/analyse/exportVipCardSaleDetailPage`, params).then((res) => res.data);
// 5.9套餐划扣页面
export const getVipCardsDeduct = (params) => axios.get(`${base}/erp/analyse/getVipCardsDeduct`, params).then((res) => res.data);
